import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpClientService } from '../../http/http-client.service';
import { CMSSessionService } from '../session/cms-session.service';
import { environment } from 'apps/portal/src/environments/environment';

export interface Token {
    access_token: string;
    expires_in: number;
    scope: string;
    token_type: string;
}

@Injectable({
    providedIn: 'root'
})
export class CMSAuthService extends HttpClientService {
    constructor(
        http: HttpClient,
        private cmsSessionService: CMSSessionService
    ) {
        super(http);
    }

    auth(): Observable<any> {
        const httpParams = new HttpParams()
            .set('grant_type', 'client_credentials')
            .set('client_id', environment.configCMS.CLIENT_ID)
            .set('client_secret', environment.configCMS.CLIENT_SECRET)
            .set('scope', 'squidex-api');
        return this.post(environment.configCMS.endPointAPI + 'identity-server/connect/token', httpParams, 'form');
    }

    setToken(token: string) {
        this.cmsSessionService.setToken(token);
    }

    getToken() {
      return this.cmsSessionService.getToken();
    }
}
